export type SerialCommandQueue = {
    run<TValue>(command: () => TValue | Promise<TValue>): Promise<TValue>;
};

export function createSerialCommandQueue(): SerialCommandQueue {
    let tail: Promise<void> = Promise.resolve();

    return {
        run<TValue>(command: () => TValue | Promise<TValue>): Promise<TValue> {
            const result = tail.then(command);
            tail = result.then(
                () => undefined,
                () => undefined
            );
            return result;
        }
    };
}
